<template>
  <v-container fluid id="due-diligence-approval">
    <DueDiligenceApproval v-if="canViewDueDiligence"/>
    <v-row v-else justify="center" class="mt-12">
      <v-col cols="auto" class="text-center">
        <v-icon size="48" color="grey">mdi-lock-outline</v-icon>
        <p class="text-subtitle-1 grey--text text--darken-1 mt-3">{{ unavailableReason }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { UserClaims } from '@/utils/Enumerations.js'
import { userAssignedClaim } from '@/utils/ClaimUtility'
import { endangeredSpeciesEnabled } from '@/utils/dueDiligence/mode.js'

export default {
  name: 'DueDiligenceApprovalView',

  components: {
    DueDiligenceApproval: () => import('@/components/due-diligence/DueDiligenceApproval.vue')
  },

  computed: {
    isSustainabilityAdmin () {
      return userAssignedClaim(UserClaims.SustainabilityAdmin)
    },

    canViewDueDiligence () {
      return this.isSustainabilityAdmin && endangeredSpeciesEnabled()
    },

    unavailableReason () {
      return this.isSustainabilityAdmin
        ? this.$t('dueDiligenceNotEnabled')
        : this.$t('sustainabilityAdminRequired')
    }
  }
}
</script>
